import { format } from "../../../core/money";

export type MoneyProps = {
  amount: number;
  currency: string;
};

export default function Money({ amount, currency }: MoneyProps) {
  return <>{format({ currencyCode: currency, amount })}</>;
}
